export const mockTransactions = [
  {
    id: 1,
    type: "sale",
    domain: "AIRevolution.com",
    domainId: 2,
    price: 12000,
    buyer: "aiEnthusiast",
    seller: "domainKing",
    timestamp: "2024-01-14T10:15:00Z",
    profit: 10800,
    buyPrice: 1200
  },
  {
    id: 2,
    type: "sale",
    domain: "QuickStart.com",
    domainId: 20,
    price: 8500,
    buyer: "startupGuru",
    seller: "cryptoQueen",
    timestamp: "2024-01-14T08:30:00Z",
    profit: 3500,
    buyPrice: 5000
  },
  {
    id: 3,
    type: "trade",
    domain: "TechBlog.com",
    domainId: 21,
    domains: ["TechBlog.com", "DevNews.io"],
    tradedFor: ["StartupHub.com"],
    buyer: "techPro",
    seller: "domainKing",
    timestamp: "2024-01-13T15:45:00Z"
  },
  {
    id: 4,
    type: "sale",
    domain: "CryptoDaily.com",
    domainId: 22,
    price: 7200,
    buyer: "cryptoQueen",
    seller: "trader456",
    timestamp: "2024-01-13T12:20:00Z",
    profit: 2200,
    buyPrice: 5000
  },
  {
    id: 5,
    type: "purchase",
    domain: "DataFlow.io",
    domainId: 23,
    price: 4500,
    buyer: "dataScientist",
    seller: "domainKing",
    timestamp: "2024-01-12T16:00:00Z"
  },
  {
    id: 6,
    type: "sale",
    domain: "HealthPlus.com",
    domainId: 24,
    price: 9800,
    buyer: "healthTechPro",
    seller: "startupGuru",
    timestamp: "2024-01-12T11:30:00Z",
    profit: 4800,
    buyPrice: 5000
  },
  {
    id: 7,
    type: "sale",
    domain: "AppForge.com",
    domainId: 25,
    price: 6700,
    buyer: "techInvestor",
    seller: "techPro",
    timestamp: "2024-01-11T14:15:00Z",
    profit: 1700,
    buyPrice: 5000
  },
  {
    id: 8,
    type: "trade",
    domain: "SmartAI.io",
    domainId: 26,
    domains: ["SmartAI.io", "MLHub.com"],
    tradedFor: ["DataScience.com", "AITools.io"],
    buyer: "aiEnthusiast",
    seller: "dataScientist",
    timestamp: "2024-01-11T09:00:00Z"
  },
  {
    id: 9,
    type: "sale",
    domain: "GameZone.com",
    domainId: 27,
    price: 11200,
    buyer: "buyer123",
    seller: "domainKing",
    timestamp: "2024-01-10T13:45:00Z",
    profit: 6200,
    buyPrice: 5000
  },
  {
    id: 10,
    type: "sale",
    domain: "FinanceHub.com",
    domainId: 28,
    price: 8900,
    buyer: "techInvestor",
    seller: "cryptoQueen",
    timestamp: "2024-01-10T10:20:00Z",
    profit: 3900,
    buyPrice: 5000
  },
];

// Generate more transactions
for (let i = 11; i <= 50; i++) {
  const users = ["domainKing", "cryptoQueen", "startupGuru", "techPro", "dataScientist", "buyer123", "trader456", "aiEnthusiast", "techInvestor"];
  const types = ["sale", "purchase"];
  const type = types[Math.floor(Math.random() * types.length)];

  const price = Math.floor(Math.random() * 10000) + 2000;

  mockTransactions.push({
    id: i,
    type,
    domain: `Domain${i}.com`,
    domainId: i + 20,
    price,
    buyer: users[Math.floor(Math.random() * users.length)],
    seller: users[Math.floor(Math.random() * users.length)],
    timestamp: new Date(Date.now() - Math.random() * 14 * 24 * 60 * 60 * 1000).toISOString(),
    profit: type === "sale" ? Math.floor(Math.random() * 5000) + 500 : undefined,
    buyPrice: type === "sale" ? Math.floor(Math.random() * 5000) + 1000 : undefined,
  });
}

export default mockTransactions;
